export const ADD_TIMING_REQUEST = 'ADD_TIMING_REQUEST'
export const ADD_TIMING_SUCCESS = 'ADD_TIMING_SUCCESS'
export const ADD_TIMING_FALIURE = 'ADD_TIMING_FALIURE'
export const ADD_GROUP_REQUEST = 'ADD_GROUP_REQUEST'
export const ADD_GROUP_SUCCESS = 'ADD_GROUP_SUCCESS'
export const ADD_GROUP_FALIURE = 'ADD_GROUP_FALIURE'
